import { Link, useNavigate } from 'react-router-dom';

import { Layout } from '../components/Layout';
import storage from 'utils/storage';
import { useEffect } from 'react';
import { Button } from 'components/Elements';

export const AccountCreatedSuccess = () => {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo({
      top: 0, // Scroll to the top
      behavior: 'smooth', // Smooth scrolling
    });
  }, []);

  return (
    <Layout title="New Account Created">
      <div className="flex flex-col space-y-2 min-h-[40vh]">
        <div className="">You've successfully created a new account with With Love Uganda. </div>
        <div className="text-sm">
          Please note that you're required to make a payment of{' '}
          <span className="text-red-500 font-bold">UGX 34,000</span> to complete your membership
          registration. Proceed and login to your account to make your initial deposit.
        </div>
        <Button onClick={() => navigate('/app')}>Proceed to account</Button>
      </div>
    </Layout>
  );
};
